// Presentation-layer translation of the authorization model into human-readable
// language. This does NOT change enforcement — the backend capability model and
// ADS remain authoritative. The UI shows a friendly ROLE and a plain-language
// summary of what the role permits; it never surfaces raw capability tokens.

// Backend role names -> friendly labels.
const ROLE_LABELS = {
  owner: "Owner",
  admin: "Administrator",
  campaign_manager: "Campaign Manager",
  staff: "Staff",
  volunteer: "Volunteer",
  viewer: "Viewer",
  support: "Support access",
};

// Resolve a friendly role label from the authoritative role NAME returned by the
// backend context. Falls back to a sensible default rather than leaking internals.
export function roleLabel(name, accessSource) {
  if (name && ROLE_LABELS[name]) return ROLE_LABELS[name];
  if (accessSource === "break_glass") return "Support access";
  if (name) {
    // Unknown but named role: Title-case the name, no raw tokens.
    return name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  }
  return "Member";
}

// A short, human-readable summary of what a user can do (deduped, ordered).
// Uses friendly phrases only — never capability tokens.
export function accessSummary(capabilities) {
  const caps = capabilities || [];
  const summary = [];
  if (caps.includes("tenant:manage")) summary.push("Manage organization settings");
  else if (caps.includes("tenant:view")) summary.push("View organization");
  if (caps.includes("member:manage")) summary.push("Manage members");
  else if (caps.includes("member:invite")) summary.push("Invite members");
  else if (caps.includes("member:view")) summary.push("View members");
  if (caps.includes("sharing:manage")) summary.push("Manage sharing & connections");
  else if (caps.includes("sharing:view")) summary.push("View sharing");
  if (caps.includes("coordination:manage_group")) summary.push("Lead coordination efforts");
  else if (caps.includes("coordination:view")) summary.push("Take part in coordination");
  return summary;
}
